var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("Header"),
          _c("img", {
            staticClass: "loading",
            attrs: { src: _vm.game.topBgImage, alt: "" },
          }),
          _c("div", { staticClass: "item_welfare" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("UserInfo", { ref: "userInfo" }),
                _c("div", { staticClass: "describe" }, [
                  _c("img", {
                    attrs: {
                      src: require("../assets/image/push.png"),
                      alt: "",
                    },
                  }),
                  _c("span", [_vm._v("|")]),
                  _c("p", { staticClass: "marquee" }, [
                    _c("span", [_vm._v(_vm._s(_vm.horseRaceLamp))]),
                  ]),
                ]),
                _c("div", { staticClass: "position" }, [
                  _c(
                    "div",
                    { staticClass: "items-grid" },
                    _vm._l(_vm.dailyRewards, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item-card" },
                        [
                          _c("div", { staticClass: "day-label" }, [
                            _vm._v("일 " + _vm._s(index + 1)),
                          ]),
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(_vm._s(item.describe)),
                          ]),
                          _c("div", { staticClass: "item-image" }, [
                            _c("img", {
                              attrs: { src: item.image, alt: item.describe },
                            }),
                            item.status == 2
                              ? _c("div", { staticClass: "completed-mark" }, [
                                  _c("div", { staticClass: "check-circle" }, [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "text-accent",
                                        attrs: {
                                          width: "62",
                                          height: "62",
                                          viewBox: "0 0 32 32",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M11.5 16.0001L14.5 19.0001L21.25 12.2501M9.00065 3.7281C10.2064 3.63188 11.3511 3.15775 12.2717 2.37319C14.4201 0.542351 17.5799 0.542351 19.7283 2.37319C20.6489 3.15775 21.7936 3.63188 22.9993 3.7281C25.8131 3.95264 28.0474 6.18698 28.272 9.00071C28.3682 10.2065 28.8423 11.3511 29.6269 12.2718C31.4577 14.4201 31.4577 17.58 29.6269 19.7284C28.8423 20.649 28.3682 21.7937 28.272 22.9994C28.0474 25.8131 25.8131 28.0475 22.9993 28.272C21.7936 28.3682 20.6489 28.8424 19.7283 29.6269C17.5799 31.4578 14.4201 31.4578 12.2717 29.6269C11.3511 28.8424 10.2064 28.3682 9.00065 28.272C6.18692 28.0475 3.95258 25.8131 3.72804 22.9994C3.63182 21.7937 3.15769 20.649 2.37313 19.7284C0.54229 17.58 0.54229 14.4201 2.37313 12.2718C3.15769 11.3511 3.63182 10.2065 3.72804 9.00071C3.95258 6.18698 6.18692 3.95264 9.00065 3.7281Z",
                                            stroke: "#fdd100",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                          _c(
                            "button",
                            {
                              class: [
                                "item-button",
                                item.status == 1
                                  ? "bg_color"
                                  : "inactive-button",
                              ],
                              attrs: { id: "btn_" + (index + 1) },
                              on: {
                                click: function ($event) {
                                  return _vm.receiveDailyRewards(
                                    index + 1,
                                    item.status
                                  )
                                },
                              },
                            },
                            [
                              item.status == 0
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "lock-icon",
                                      attrs: {
                                        viewBox: "0 0 24 24",
                                        width: "14",
                                        height: "14",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M19,10h-1V7c0-4-3-7-7-7S4,3,4,7v3H3c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-8C21,10.9,20.1,10,19,10z M12,17c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,17,12,17z M15,10H9V7c0-1.7,1.3-3,3-3s3,1.3,3,3V10z",
                                          fill: "currentColor",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.loadingDay === index + 1 && item.status == 1
                                ? _c("span")
                                : _vm._e(),
                              item.status != 0 && _vm.loadingDay == null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.status == 2 ? "수령완료" : "수령"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._m(1),
                ]),
              ],
              1
            ),
          ]),
          _c("Footer"),
        ],
        1
      ),
      _c("TipsWindow", { ref: "tips" }),
      _vm.showRewardModal
        ? _c(
            "div",
            {
              staticClass: "reward-modal",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeRewardModal.apply(null, arguments)
                },
              },
            },
            [
              _vm.showFireworks
                ? _c(
                    "div",
                    { staticClass: "fireworks-container" },
                    _vm._l(10, function (n) {
                      return _c("div", {
                        key: n,
                        staticClass: "firework-rocket",
                      })
                    }),
                    0
                  )
                : _vm._e(),
              _c("div", { staticClass: "reward-modal-content" }, [
                _c("div", { staticClass: "reward-modal-header" }, [
                  _c("div", { staticClass: "header-decoration" }),
                  _c("h3", [_vm._v("수상을 축하합니다")]),
                  _c(
                    "span",
                    {
                      staticClass: "close-btn",
                      on: { click: _vm.closeRewardModal },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _c("div", { staticClass: "reward-modal-body" }, [
                  _c("div", { staticClass: "reward-image-container" }, [
                    _c("div", { staticClass: "reward-image-wrapper" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.currentReward.image,
                          alt: _vm.currentReward.describe,
                        },
                      }),
                      _c("div", { staticClass: "reward-glow" }),
                    ]),
                  ]),
                  _c("div", { staticClass: "reward-info" }, [
                    _c("p", { staticClass: "reward-title" }, [
                      _vm._v(_vm._s(_vm.currentReward.describe)),
                    ]),
                    _c("p", { staticClass: "reward-desc" }, [
                      _vm._v(
                        "수령 성공, 해당 보상은 우편을 통해 발송해 드렸으니 어서 로그인하여 우편함을 확인하세요."
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "reward-modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.closeRewardModal },
                    },
                    [_c("span", [_vm._v("확인")])]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "naverwebtoon" }, [
      _c("img", {
        staticClass: "close b-close",
        attrs: { src: require("../assets/image/close.png"), alt: "" },
      }),
      _c("a", { attrs: { href: "" } }, [
        _c("img", {
          attrs: {
            src: require("../assets/image/naverwebtoon_bigbanner.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "game-rules" }, [
      _c("h3", [_vm._v("1.5주년 혜택 안내")]),
      _c("p", [
        _vm._v(
          "\n\t\t\t\t\t\t\t1. 웹사이트을 통해 60선옥을 충전하시면, 7일 보상 수령 가능합니다. 7일 (매일 1회)"
        ),
        _c("br"),
        _vm._v(
          "\n\t\t\t\t\t\t\t2. 웹사이트을 통해 680선옥을 충전하시면, 14일 보상 수령 가능합니다.(매일 1회)"
        ),
        _c("br"),
        _vm._v(
          "\n\t\t\t\t\t\t\t3. 웹사이트을 통해 1980선옥을 충전하시면, 21일 보상 수령 가능합니다.(매일 1회)"
        ),
        _c("br"),
        _vm._v(
          "\n\t\t\t\t\t\t\t4. 웹사이트을 통해 6480선옥 충전하시면, 30일 보상 수령 가능합니다.(매일 1회)\n\t\t\t\t\t\t"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }